exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-password-input{margin:0 15px;-webkit-user-select:none;user-select:none;position:relative}.van-password-input:focus{outline:0}.van-password-input__error-info,.van-password-input__info{font-size:14px;margin-top:15px;text-align:center}.van-password-input__info{color:#969799}.van-password-input__error-info{color:#f44}.van-password-input__security{width:100%;height:50px;display:-webkit-box;display:-webkit-flex;display:flex;background-color:#fff}.van-password-input__security:after{border-radius:6px}.van-password-input__security li{-webkit-box-flex:1;-webkit-flex:1;flex:1;height:100%;position:relative;font-size:20px;line-height:50px;text-align:center}.van-password-input__security li:not(:first-of-type):after{border-left-width:1px}.van-password-input__security i{position:absolute;left:50%;top:50%;width:10px;height:10px;margin:-5px 0 0 -5px;visibility:hidden;border-radius:100%;background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vant/es/password-input/index.css
// module id = 276
// module chunks = 0